import React from 'react';
import dayjs from 'dayjs';

import { Stream } from '$partials/modules';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ArticlePage}
 */
const ArticlePage = (props) => {
    const page = props.data?.page || {};
    const date = dayjs(page?.publicationDate).format('D MM YYYY');
    const categories = page?.categories;

    return (
        <main className='container'>
            <div className='hide col-12 md-show'>
                <div className='flex flex-wrap col-5 pb5 md-pb4'>
                    {categories.map((category, idx) => {
                        return (
                            <p
                                className='type-style-5 mr2'
                                key={category?.id}>{category?.label}{categories?.length > 1 && idx !== categories?.length -1 ? ',' : ''}</p>);
                    })}
                </div>
            </div>
            <div className='col-12 flex flex-wrap'>
                <div className='col-12 sm-col-6 md-col-5 pb7 sm-pb0'>
                    <div className='flex flex-wrap'>
                        {categories.map((category, idx) => {
                            return (
                                <p
                                    className='type-style-5 md-hide mr2'
                                    key={category?.id}>{category?.label}{categories?.length > 1 && idx !== categories?.length -1 ? ', ' : ''}{' '}</p>);
                        })}
                    </div>
                    <h1 className='type-style-1'>{page?.title}</h1>
                    <div className='flex pt4 md-pt5'>
                        <p className='type-style-5 '>{date?.replaceAll(' ', '.')}</p>
                        {(page.author) && (
                            <p className='ml5 type-style-5 black inline'>{`Words by ${page.author}`}</p>
                        )}
                    </div>
                </div>
                <div className='hide md-show col-1'/>
                <div className='col-12 sm-col-6 md-col-4'>
                    <div
                        className='rich-text type-style-3 pb6 sm-pb5 md-pb6'
                        dangerouslySetInnerHTML={{__html: page?.standfirst}}/>
                    <div
                        className='rich-text article-page-body type-style-6'
                        dangerouslySetInnerHTML={{__html: page?.body}}/>
                </div>
            </div>

            {/* modules */}
            <Stream
                modules={page?.modules}
                namespace='article-page' />
        </main>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ArticlePage;
